import styled from 'styled-components';

export const FooterWrapper = styled.div`
  grid-area: footer;
  position: relative;
  z-index: 0;

  #txt_1008:first-child,
  #txt_1010:first-child,
  .sv-col.sv--sml-6 #txt_1010 {
    @media screen and (max-width: 1248px) {
      margin-top: 20px;
    }
  }

  .sv-footer__inner {
    width: 100%;
    max-width: 1680px;
    margin: 0 auto;
    padding: 32px 86px 0;

    @media screen and (${(props) => props.theme.media.widthLtXlrg}) {
      padding: 24px 30px;
    }

    @media screen and (${(props) => props.theme.media.widthLtMed}) {
      padding: 16px 10px;
    }

    .sv-footer__body .vx--footer_list-item a {
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      color: #a3a4a9;
      transition: color 0.15s ease-out;
    }
    .sv-footer__body .vx--footer_list-item > ul li a {
      color: #a3a4a9;
      padding: 0;
      background: none;
      font-weight: 300;
      line-height: 1.1rem;
    }
    .sv-footer__body .vx--footer_list-item > ul li a:hover {
      color: #fff;
    }

    .sv-footer__body .vx--footer_list-item > ul li a:before,
    .sv-footer__body .vx--footer_list-item > ul li a:after {
      color: #a3a4a9;
      padding: 0;
      border: 0;
      background: none;
    }

    .sv-footer__body .vx--footer_list-item ul {
      margin-bottom: 0;
    }

    .sv-footer__body .vx--footer_list-item ul li {
      padding: 0;
      font-size: 0.6875rem;
    }
    .sv-footer__body .vx--footer_list-item > ul li::before,
    .sv-footer__body .vx--footer_list-item > ul li::after {
      background-color: none;
      border-radius: 0;
      height: 0;
      left: 0;
      top: 0;
      width: 0;
    }

    .sv-social__action.sv--linkedin::after {
      background-size: contain;
      height: 1.5625rem;
      width: 1.5625rem;
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M507 310.6v185.6H399.4V323.1c0-43.5-15.5-73.2-54.5-73.2-29.7 0-47.4 20-55.2 39.4-2.8 6.9-3.6 16.5-3.6 26.2v180.8H178.5s1.4-293.3 0-323.7h107.6v45.9c-.2.4-.5.7-.7 1.1h.7v-1.1c14.3-22 39.8-53.5 97-53.5 70.8 0 123.9 46.2 123.9 145.6zM65.9 16.6C29.1 16.6 5 40.7 5 72.5c0 31.1 23.4 55.9 59.5 55.9h.7c37.5 0 60.9-24.9 60.9-55.9-.7-31.8-23.4-55.9-60.2-55.9zM11.4 496.2H119V172.6H11.4v323.6zm0 0' fill='%23fff'/%3E%3C/svg%3E");
      left: 50%;
      top: 42%;
      transform: translate(-0.7813rem, -0.7813rem);
    }

    .sv-social__action.sv--instagram::after {
      background-size: contain;
      height: 1.5625rem;
      width: 1.5625rem;
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cpath d='M367.8 6.3H143.4C67.2 6.3 5.3 68.2 5.3 144.4v224.4C5.3 445 67.2 507 143.4 507h224.4C444 507 506 445 506 368.8V144.4C506 68.2 444 6.3 367.8 6.3zm93.8 362.5c0 51.7-42.1 93.8-93.8 93.8H143.4c-51.7 0-93.8-42.1-93.8-93.8V144.4c0-51.7 42.1-93.8 93.8-93.8h224.4c51.7 0 93.8 42.1 93.8 93.8v224.4zm0 0M255.6 127.6c-71.2 0-129 57.9-129 129 0 71.2 57.9 129 129 129s129-57.9 129-129c.1-71.1-57.8-129-129-129zm0 213.6c-46.6 0-84.6-37.9-84.6-84.6 0-46.6 38-84.6 84.6-84.6s84.6 38 84.6 84.6c0 46.7-37.9 84.6-84.6 84.6zm0 0M390.1 89.9c-8.6 0-17 3.5-23 9.5-6.1 6-9.6 14.5-9.6 23.1 0 8.6 3.5 17 9.6 23 6 6 14.4 9.5 23 9.5s17-3.5 23-9.5c6.1-6.1 9.5-14.5 9.5-23 0-8.6-3.5-17-9.5-23.1-6-6-14.4-9.5-23-9.5zm0 0' fill='%23fff'/%3E%3C/svg%3E");
      left: 50%;
      transform: translate(-0.7813rem, -0.7813rem);
    }

    .sv-social__action.sv-onthemarket {
      height: 4rem !important;
      width: 10rem;
      padding-left: 0;
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 710 194'%3E%3Cpath d='M142.8 72.7c0-2.8 1.7-4.6 4.3-4.6 2.7 0 4.3 1.8 4.3 4.6v2.1l.2.2c3.8-4.9 9.2-6.9 14.5-6.9 8.1 0 18.2 5.1 18.2 19.8v28.9c0 2.8-1.7 4.6-4.3 4.6-2.7 0-4.3-1.8-4.3-4.6V88.4c0-9.1-6.4-12.8-12.1-12.8-5.7 0-12.1 3.7-12.1 12.8v28.4c0 2.8-1.7 4.6-4.3 4.6-2.6 0-4.3-1.8-4.3-4.6V72.7zM198.9 59.1h-13.1c-2.5 0-4.2-1.3-4.2-4s1.8-4 4.2-4h34.8c2.5 0 4.2 1.3 4.2 4 0 2.8-1.8 4-4.2 4h-13.1v57.7c0 2.8-1.7 4.6-4.3 4.6-2.7 0-4.3-1.8-4.3-4.6V59.1zM261 88.4c0-9.1-6.4-12.8-12.1-12.8-5.7 0-12.1 3.7-12.1 12.8v28.4c0 2.8-1.7 4.6-4.3 4.6-2.7 0-4.3-1.8-4.3-4.6v-67c0-2.8 1.7-4.6 4.3-4.6 2.7 0 4.3 1.8 4.3 4.6v25l.2.2c3.8-4.9 9.3-6.9 14.5-6.9 8.1 0 18.2 5.1 18.2 19.8v28.9c0 2.8-1.7 4.6-4.3 4.6-2.7 0-4.3-1.8-4.3-4.6V88.4zM282.1 98.1c0 8.9 5.7 15.9 15.4 15.9 11.5 0 14.5-7.1 17.7-7.1 1.6 0 3.1 1.4 3.1 3.8 0 4.2-10.7 10.7-21 10.7-16.7 0-24-12.9-24-26.7 0-14.1 8.9-26.7 23.5-26.7 14.3 0 22.6 12.9 22.6 25.4 0 3-1.1 4.6-4.8 4.6h-32.5zm28.7-6.5c0-7.4-4.3-16.1-13.9-16.1-10.7-.4-14.5 8.1-14.8 16.1h28.7zM331 117.7c-.4 3.1-2.4 3.7-4.6 3.7-2.7 0-4-1.8-4-4.4 0-1 .2-2.2.5-3.9l9.6-56.1c.9-4.9 3.6-6.5 6.8-6.5 3.5 0 5.3 1.3 6.3 4.5l15 51.1h.2l15-51.1c1-3.2 2.8-4.5 6.3-4.5 3.2 0 5.9 1.6 6.8 6.5l9.5 56.1c.3 1.7.5 2.9.5 3.9 0 2.6-1.4 4.4-4 4.4-2.3 0-4.2-.7-4.6-3.7l-8.2-56.1h-.2L365 117.9c-.9 2.9-2.5 3.6-4.4 3.6-2 0-3.5-.7-4.4-3.6l-16.7-56.3h-.2l-8.3 56.1zM445.7 117.2c0 3-2.4 4.2-4 4.2-1.8 0-4.1-1.2-4.1-4.2v-3.6h-.2c-3.7 5.3-8.6 7.8-14.2 7.8-14.8 0-23.1-12.9-23.1-26.7 0-13.8 8.3-26.7 23.1-26.7 6 0 10.2 2.5 14.2 7h.2v-2.8c0-3 2.3-4.2 4.1-4.2 1.6 0 4 1.2 4 4.2v45zm-22.5-3.2c10.6 0 14.4-10.4 14.4-19.2 0-8.8-3.7-19.2-14.4-19.2-10.6 0-14.4 10.4-14.4 19.2 0 8.8 3.7 19.2 14.4 19.2M452.8 72.7c0-2.8 1.7-4.6 4.3-4.6s4.4 1.8 4.4 4.6v4.4h.2c2-4 6.8-9 11.8-9 3 0 4.8 2 4.8 4.4 0 2.5-1.8 4-5.4 4.7-5.1.9-11.4 4.7-11.4 14.8v24.8c0 2.8-1.7 4.6-4.4 4.6s-4.3-1.8-4.3-4.6V72.7zM482 49.8c0-2.8 1.7-4.6 4.3-4.6 2.7 0 4.3 1.8 4.3 4.6v36.8l18.9-15.8c1.8-1.6 3.4-2.6 4.9-2.6 2.3 0 3.6 1.7 3.6 3.8 0 1.3-.5 2.5-2.1 3.7l-19.7 15.5 22.8 22.5c1.7 1.6 2.1 2.7 2.1 4.4 0 2-1.8 3.4-3.7 3.4-2.1 0-3-.6-5-2.7L490.6 96v20.8c0 2.8-1.7 4.6-4.3 4.6-2.6 0-4.3-1.8-4.3-4.6v-67zM528.5 98.1c0 8.9 5.7 15.9 15.4 15.9 11.5 0 14.5-7.1 17.7-7.1 1.6 0 3.1 1.4 3.1 3.8 0 4.2-10.7 10.7-21 10.7-16.7 0-24-12.9-24-26.7 0-14.1 8.9-26.7 23.6-26.7 14.3 0 22.5 12.9 22.5 25.4 0 3-1.1 4.6-4.8 4.6h-32.5zm28.8-6.5c0-7.4-4.3-16.1-13.9-16.1-10.7-.4-14.6 8.1-14.9 16.1h28.8zM573.6 57.4c0-2.8 1.7-4.6 4.3-4.6 2.7 0 4.3 1.8 4.3 4.6v11.3h3.6c2.9 0 4.3 1.4 4.3 3.7 0 2.3-1.5 3.7-4.3 3.7h-3.6v40.7c0 2.8-1.7 4.6-4.3 4.6-2.6 0-4.3-1.8-4.3-4.6V76.2h-3.5c-2.8 0-4.3-1.4-4.3-3.7 0-2.4 1.5-3.7 4.3-3.7h3.5V57.4zM591.7 115.9c1.4 0 2.6 1.2 2.6 2.6 0 1.4-1.2 2.6-2.6 2.6-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6M612 93.4c4.6 0 7.3 1.6 7.3 3.4 0 .9-.8 1.9-1.8 1.9-1.7 0-2.4-1.4-5.5-1.4-5.6 0-7.8 5.4-7.8 10s2.2 10 7.8 10c3.2 0 4-1.5 5.4-1.5 1 0 1.7.7 1.7 1.9 0 1.7-2.5 3.5-7.2 3.5-8.3 0-12.3-6.7-12.3-13.9.1-7.2 4.1-13.9 12.4-13.9M633.2 93.4c7.7 0 12 6.7 12 13.9s-4.3 13.9-12 13.9-12-6.7-12-13.9 4.3-13.9 12-13.9m0 23.9c5.5 0 7.5-5.4 7.5-10s-1.9-10-7.5-10c-5.5 0-7.5 5.4-7.5 10s1.9 10 7.5 10M666.2 103.5c0-3.9-2.2-6.3-5.9-6.3-3.6 0-5.8 2.4-5.8 6.3v15.2c0 1.5-.9 2.4-2.3 2.4s-2.3-.9-2.3-2.4v-23c0-1.5.9-2.4 2.3-2.4s2.3.9 2.3 2.4v.8l.1.1c1.1-1.4 2.8-3.3 6.9-3.3 2.7 0 5.4 1.1 7.5 4.6 2-2.9 4.4-4.6 8.4-4.6 4.2 0 9.5 2.7 9.5 10.3v15c0 1.5-.9 2.4-2.3 2.4s-2.3-.9-2.3-2.4v-15.2c0-3.9-2.2-6.3-5.8-6.3-3.6 0-5.8 2.4-5.8 6.3v15.2c0 1.5-.9 2.4-2.3 2.4s-2.2-.9-2.2-2.4v-15.1zM84.8 35.8c-28.7 0-51.9 23.1-51.9 51.8 0 17.5 8.7 33 22.1 42.3l29.5 39.9 29.1-39.1c14-9.3 23.3-25.1 23.3-43.1-.1-28.7-23.4-51.8-52.1-51.8m0 88.9c-20.6 0-37.4-16.7-37.4-37.2 0-20.6 16.7-37.2 37.4-37.2 20.6 0 37.4 16.7 37.4 37.2 0 20.6-16.7 37.2-37.4 37.2M58.6 87.5c0-14.5 11.7-26.1 26.2-26.1S111 73.1 111 87.5c0 14.4-11.8 26.1-26.2 26.1-14.4 0-26.2-11.7-26.2-26.1' fill='%23fff'/%3E%3C/svg%3E"); /** IE11N**/
      background-size: 150px 50px;
      background-repeat: no-repeat;
      background-position: -7px;
      height: 18px;
      display: block;
    }
  }
  .sv-footer__footer {
    background: none;
  }

  // old footer grid styles
  :root {
    --sv-base-size: 16px;
    --sv-min-width: 320px;
    --sv-max-width: 1248px;
    --sv-gutter: 16px;

    /* Added named default gutter size for the purpose associative loops */
    --sv-gutter-xsml: 8px;
    --sv-gutter-sml: 16px;
    --sv-gutter-med: 24px;
    --sv-gutter-lrg: 32px;
    --sv-gutter-xlrg: 64px;
    --sv-gutter-xxlrg: 128px;

    /* Added intermediate gutter size for the purpose associative loops */
    --sv-gutter-xsml-mid: 12px;
    --sv-gutter-sml-mid: 20px;
    --sv-gutter-med-mid: 28px;
    --sv-gutter-lrg-mid: 48px;
    --sv-gutter-xlrg-mid: 96px;
    --sv-gutter-xxlrg-mid: 112px;

    /* globals */
    --sv-header-height-sml: 50px;
    --sv-header-height-med: 66px;
    --sv-header-height-lrg: 89px;
  }

  .sv-block-grid,
  .sv-contained,
  .sv-row {
    max-width: var(1248px);
    margin-left: auto;
    margin-right: auto;
  }

  .sv-block-grid::before,
  .sv-contained::before,
  .sv-row::before {
    content: '';
    display: table;
  }

  .sv-block-grid::after,
  .sv-contained::after,
  .sv-row::after {
    content: '';
    display: table;
    clear: both;
  }

  .sv-block-grid .sv--contained,
  .sv-block-grid .sv-block-grid,
  .sv-block-grid .sv-row,
  .sv-contained .sv--contained,
  .sv-contained .sv-block-grid,
  .sv-contained .sv-row,
  .sv-row .sv--contained,
  .sv-row .sv-block-grid,
  .sv-row .sv-row {
    padding: 0;
  }

  .sv-row::after,
  .sv-row::before {
    content: '';
    display: table;
  }

  .sv-row::after {
    clear: both;
  }

  .sv-col {
    list-style: none;
  }

  .sv-col::after,
  .sv-col::before {
    content: '';
    display: table;
  }

  .sv-col::after {
    clear: both;
  }

  .sv-col.sv--center {
    margin: 0 auto !important;
    float: none !important;
  }

  .sv-block-grid::after,
  .sv-block-grid::before {
    content: '';
    display: table;
  }

  .sv-block-grid::after {
    clear: both;
  }

  .sv-block-grid > .sv-col {
    margin-bottom: var(--sv-gutter);
  }

  @media screen and (max-width: 1247px) {
    .sv-block-grid,
    .sv-contained,
    .sv-row {
      padding: 0 var(--sv-gutter);
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1135px) {
    .sv-block-grid,
    .sv-contained,
    .sv-row {
      padding: 0 var(--sv-gutter-lrg);
    }
  }

  @media screen and (min-width: 768px) {
    .sv-col.sv--offset-top {
      margin-top: -5rem;
    }

    .sv-row.sv--sml-right > .sv-col {
      float: right !important;
      margin-right: 0 !important;
      margin-left: var(--sv-gutter);
    }

    .sv-row.sv--sml-right > .sv-col:last-child {
      margin-left: 0;
    }

    .sv-row.sv--sml-equal {
      display: flex;
      flex-wrap: wrap;
    }

    .sv-row.sv--sml-equal > .sv-col {
      display: flex;
    }

    .sv-col.sv--sml-1 {
      width: calc(8.325% - 0.91667rem);
    }

    .sv-col.sv--sml-1:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-1:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-1:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-1:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-2 {
      width: calc(16.65% - 0.83333rem);
    }

    .sv-col.sv--sml-2:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-2:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-2:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-2:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-3 {
      width: calc(24.975% - 0.75rem);
    }

    .sv-col.sv--sml-3:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-3:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-3:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-3:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-4 {
      width: calc(33.3% - 0.66667rem);
    }

    .sv-col.sv--sml-4:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-4:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-4:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-4:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-5 {
      width: calc(41.625% - 0.58333rem);
    }

    .sv-col.sv--sml-5:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-5:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-5:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-5:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-6 {
      width: calc(49.95% - 0.5rem);
    }

    .sv-col.sv--sml-6:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-6:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-6:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-6:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-7 {
      width: calc(58.275% - 0.41667rem);
    }

    .sv-col.sv--sml-7:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-7:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-7:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-7:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-8 {
      width: calc(66.6% - 0.33333rem);
    }

    .sv-col.sv--sml-8:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-8:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-8:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-8:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-9 {
      width: calc(74.925% - 0.25rem);
    }

    .sv-col.sv--sml-9:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-9:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-9:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-9:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-10 {
      width: calc(83.25% - 0.16667rem);
    }

    .sv-col.sv--sml-10:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-10:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-10:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-10:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-11 {
      width: calc(91.575% - 0.08333rem);
    }

    .sv-col.sv--sml-11:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-11:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-11:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-11:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-12 {
      width: 99.9%;
    }

    .sv-col.sv--sml-12:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--sml-12:last-child {
      margin-right: 0;
    }

    .sv-col.sv--sml-12:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--sml-12:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--sml-offset-1 {
      margin-left: calc(8.325% + 0.08333rem) !important;
    }

    .sv-col.sv--sml-offset-2 {
      margin-left: calc(16.65% + 0.16667rem) !important;
    }

    .sv-col.sv--sml-offset-3 {
      margin-left: calc(24.975% + 0.25rem) !important;
    }

    .sv-col.sv--sml-offset-4 {
      margin-left: calc(33.3% + 0.33333rem) !important;
    }

    .sv-col.sv--sml-offset-5 {
      margin-left: calc(41.625% + 0.41667rem) !important;
    }

    .sv-col.sv--sml-offset-6 {
      margin-left: calc(49.95% + 0.5rem) !important;
    }

    .sv-col.sv--sml-offset-7 {
      margin-left: calc(58.275% + 0.58333rem) !important;
    }

    .sv-col.sv--sml-offset-8 {
      margin-left: calc(66.6% + 0.66667rem) !important;
    }

    .sv-col.sv--sml-offset-9 {
      margin-left: calc(74.925% + 0.75rem) !important;
    }

    .sv-col.sv--sml-offset-10 {
      margin-left: calc(83.25% + 0.83333rem) !important;
    }

    .sv-col.sv--sml-offset-11 {
      margin-left: calc(91.575% + 0.91667rem) !important;
    }

    .sv-col.sv--sml-offset-12 {
      margin-left: calc(99.9% + 1rem) !important;
    }
  }

  @media screen and (min-width: 320px) {
    .sv-row.sv--xsml-right > .sv-col {
      float: right !important;
      margin-right: 0 !important;
      margin-left: var(--sv-gutter);
    }

    .sv-row.sv--xsml-right > .sv-col:last-child {
      margin-left: 0;
    }

    .sv-row.sv--xsml-equal {
      display: flex;
      flex-wrap: wrap;
    }

    .sv-row.sv--xsml-equal > .sv-col {
      display: flex;
    }

    .sv-col.sv--xsml-1 {
      width: calc(8.325% - 0.91667rem);
    }

    .sv-col.sv--xsml-1:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-1:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-1:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-1:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-2 {
      width: calc(16.65% - 0.83333rem);
    }

    .sv-col.sv--xsml-2:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-2:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-2:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-2:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-3 {
      width: calc(24.975% - 0.75rem);
    }

    .sv-col.sv--xsml-3:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-3:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-3:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-3:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-4 {
      width: calc(33.3% - 0.66667rem);
    }

    .sv-col.sv--xsml-4:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-4:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-4:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-4:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-5 {
      width: calc(41.625% - 0.58333rem);
    }

    .sv-col.sv--xsml-5:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-5:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-5:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-5:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-6 {
      width: calc(49.95% - 0.5rem);
    }

    .sv-col.sv--xsml-6:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-6:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-6:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-6:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-7 {
      width: calc(58.275% - 0.41667rem);
    }

    .sv-col.sv--xsml-7:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-7:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-7:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-7:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-8 {
      width: calc(66.6% - 0.33333rem);
    }

    .sv-col.sv--xsml-8:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-8:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-8:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-8:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-9 {
      width: calc(74.925% - 0.25rem);
    }

    .sv-col.sv--xsml-9:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-9:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-9:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-9:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-10 {
      width: calc(83.25% - 0.16667rem);
    }

    .sv-col.sv--xsml-10:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-10:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-10:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-10:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-11 {
      width: calc(91.575% - 0.08333rem);
    }

    .sv-col.sv--xsml-11:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-11:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-11:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-11:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-12 {
      width: 99.9%;
    }

    .sv-col.sv--xsml-12:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--xsml-12:last-child {
      margin-right: 0;
    }

    .sv-col.sv--xsml-12:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--xsml-12:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--xsml-offset-1 {
      margin-left: calc(8.325% + 0.08333rem) !important;
    }

    .sv-col.sv--xsml-offset-2 {
      margin-left: calc(16.65% + 0.16667rem) !important;
    }

    .sv-col.sv--xsml-offset-3 {
      margin-left: calc(24.975% + 0.25rem) !important;
    }

    .sv-col.sv--xsml-offset-4 {
      margin-left: calc(33.3% + 0.33333rem) !important;
    }

    .sv-col.sv--xsml-offset-5 {
      margin-left: calc(41.625% + 0.41667rem) !important;
    }

    .sv-col.sv--xsml-offset-6 {
      margin-left: calc(49.95% + 0.5rem) !important;
    }

    .sv-col.sv--xsml-offset-7 {
      margin-left: calc(58.275% + 0.58333rem) !important;
    }

    .sv-col.sv--xsml-offset-8 {
      margin-left: calc(66.6% + 0.66667rem) !important;
    }

    .sv-col.sv--xsml-offset-9 {
      margin-left: calc(74.925% + 0.75rem) !important;
    }

    .sv-col.sv--xsml-offset-10 {
      margin-left: calc(83.25% + 0.83333rem) !important;
    }

    .sv-col.sv--xsml-offset-11 {
      margin-left: calc(91.575% + 0.91667rem) !important;
    }

    .sv-col.sv--xsml-offset-12 {
      margin-left: calc(99.9% + 1rem) !important;
    }
  }

  @media screen and (min-width: 1024px) {
    .sv-row.sv--med-right > .sv-col {
      float: right !important;
      margin-right: 0 !important;
      margin-left: var(--sv-gutter);
    }

    .sv-row.sv--med-right > .sv-col:last-child {
      margin-left: 0;
    }

    .sv-row.sv--med-equal {
      display: flex;
      flex-wrap: wrap;
    }

    .sv-row.sv--med-equal > .sv-col {
      display: flex;
    }

    .sv-col.sv--med-1 {
      width: calc(8.325% - 0.91667rem);
    }

    .sv-col.sv--med-1:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-1:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-1:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-1:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-2 {
      width: calc(16.65% - 0.83333rem);
    }

    .sv-col.sv--med-2:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-2:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-2:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-2:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-3 {
      width: calc(24.975% - 0.75rem);
    }

    .sv-col.sv--med-3:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-3:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-3:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-3:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-4 {
      width: calc(33.3% - 0.66667rem);
    }

    .sv-col.sv--med-4:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-4:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-4:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-4:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-5 {
      width: calc(41.625% - 0.58333rem);
    }

    .sv-col.sv--med-5:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-5:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-5:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-5:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-6 {
      width: calc(49.95% - 0.5rem);
    }

    .sv-col.sv--med-6:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-6:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-6:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-6:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-7 {
      width: calc(58.275% - 0.41667rem);
    }

    .sv-col.sv--med-7:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-7:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-7:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-7:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-8 {
      width: calc(66.6% - 0.33333rem);
    }

    .sv-col.sv--med-8:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-8:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-8:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-8:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-9 {
      width: calc(74.925% - 0.25rem);
    }

    .sv-col.sv--med-9:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-9:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-9:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-9:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-10 {
      width: calc(83.25% - 0.16667rem);
    }

    .sv-col.sv--med-10:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-10:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-10:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-10:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-11 {
      width: calc(91.575% - 0.08333rem);
    }

    .sv-col.sv--med-11:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-11:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-11:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-11:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-12 {
      width: 99.9%;
    }

    .sv-col.sv--med-12:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--med-12:last-child {
      margin-right: 0;
    }

    .sv-col.sv--med-12:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--med-12:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--med-offset-1 {
      margin-left: calc(8.325% + 0.08333rem) !important;
    }

    .sv-col.sv--med-offset-2 {
      margin-left: calc(16.65% + 0.16667rem) !important;
    }

    .sv-col.sv--med-offset-3 {
      margin-left: calc(24.975% + 0.25rem) !important;
    }

    .sv-col.sv--med-offset-4 {
      margin-left: calc(33.3% + 0.33333rem) !important;
    }

    .sv-col.sv--med-offset-5 {
      margin-left: calc(41.625% + 0.41667rem) !important;
    }

    .sv-col.sv--med-offset-6 {
      margin-left: calc(49.95% + 0.5rem) !important;
    }

    .sv-col.sv--med-offset-7 {
      margin-left: calc(58.275% + 0.58333rem) !important;
    }

    .sv-col.sv--med-offset-8 {
      margin-left: calc(66.6% + 0.66667rem) !important;
    }

    .sv-col.sv--med-offset-9 {
      margin-left: calc(74.925% + 0.75rem) !important;
    }

    .sv-col.sv--med-offset-10 {
      margin-left: calc(83.25% + 0.83333rem) !important;
    }

    .sv-col.sv--med-offset-11 {
      margin-left: calc(91.575% + 0.91667rem) !important;
    }

    .sv-col.sv--med-offset-12 {
      margin-left: calc(99.9% + 1rem) !important;
    }
  }

  @media screen and (min-width: 1136px) {
    .sv-row.sv--lrg-right > .sv-col {
      float: right !important;
      margin-right: 0 !important;
      margin-left: var(--sv-gutter);
    }

    .sv-row.sv--lrg-right > .sv-col:last-child {
      margin-left: 0;
    }

    .sv-row.sv--lrg-equal {
      display: flex;
      flex-wrap: wrap;
    }

    .sv-row.sv--lrg-equal > .sv-col {
      display: flex;
    }

    .sv-col.sv--lrg-1 {
      width: calc(8.325% - 0.91667rem);
    }

    .sv-col.sv--lrg-1:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-1:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-1:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-1:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-2 {
      width: calc(16.65% - 0.83333rem);
    }

    .sv-col.sv--lrg-2:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-2:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-2:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-2:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-3 {
      width: calc(24.975% - 0.75rem);
    }

    .sv-col.sv--lrg-3:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-3:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-3:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-3:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-4 {
      width: calc(33.3% - 0.66667rem);
    }

    .sv-col.sv--lrg-4:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-4:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-4:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-4:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-5 {
      width: calc(41.625% - 0.58333rem);
    }

    .sv-col.sv--lrg-5:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-5:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-5:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-5:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-6 {
      width: calc(49.95% - 0.5rem);
    }

    .sv-col.sv--lrg-6:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-6:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-6:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-6:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-7 {
      width: calc(58.275% - 0.41667rem);
    }

    .sv-col.sv--lrg-7:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-7:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-7:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-7:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-8 {
      width: calc(66.6% - 0.33333rem);
    }

    .sv-col.sv--lrg-8:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-8:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-8:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-8:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-9 {
      width: calc(74.925% - 0.25rem);
    }

    .sv-col.sv--lrg-9:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-9:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-9:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-9:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-10 {
      width: calc(83.25% - 0.16667rem);
    }

    .sv-col.sv--lrg-10:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-10:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-10:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-10:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-11 {
      width: calc(91.575% - 0.08333rem);
    }

    .sv-col.sv--lrg-11:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-11:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-11:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-11:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-12 {
      width: 99.9%;
    }

    .sv-col.sv--lrg-12:nth-child(1n) {
      float: left;
      margin-right: 1rem;
      clear: none;
    }

    .sv-col.sv--lrg-12:last-child {
      margin-right: 0;
    }

    .sv-col.sv--lrg-12:nth-child(12n) {
      margin-right: 0;
      float: right;
    }

    .sv-col.sv--lrg-12:nth-child(12n + 1) {
      clear: both;
    }

    .sv-col.sv--lrg-offset-1 {
      margin-left: calc(8.325% + 0.08333rem) !important;
    }

    .sv-col.sv--lrg-offset-2 {
      margin-left: calc(16.65% + 0.16667rem) !important;
    }

    .sv-col.sv--lrg-offset-3 {
      margin-left: calc(24.975% + 0.25rem) !important;
    }

    .sv-col.sv--lrg-offset-4 {
      margin-left: calc(33.3% + 0.33333rem) !important;
    }

    .sv-col.sv--lrg-offset-5 {
      margin-left: calc(41.625% + 0.41667rem) !important;
    }

    .sv-col.sv--lrg-offset-6 {
      margin-left: calc(49.95% + 0.5rem) !important;
    }

    .sv-col.sv--lrg-offset-7 {
      margin-left: calc(58.275% + 0.58333rem) !important;
    }

    .sv-col.sv--lrg-offset-8 {
      margin-left: calc(66.6% + 0.66667rem) !important;
    }

    .sv-col.sv--lrg-offset-9 {
      margin-left: calc(74.925% + 0.75rem) !important;
    }

    .sv-col.sv--lrg-offset-10 {
      margin-left: calc(83.25% + 0.83333rem) !important;
    }

    .sv-col.sv--lrg-offset-11 {
      margin-left: calc(91.575% + 0.91667rem) !important;
    }

    .sv-col.sv--lrg-offset-12 {
      margin-left: calc(99.9% + 1rem) !important;
    }
  }

  @media screen and (min-width: 1248px) {
    .sv-row.sv--xlrg-right > .sv-col {
      float: right !important;
      margin-right: 0 !important;
      margin-left: var(--sv-gutter);
    }

    .sv-row.sv--xlrg-right > .sv-col:last-child {
      margin-left: 0;
    }

    .sv-row.sv--xlrg-equal {
      display: flex;
      flex-wrap: wrap;
    }

    .sv-row.sv--xlrg-equal > .sv-col {
      display: flex;
    }
  }

  // footer styles
  .sv-footer {
    position: relative;
    z-index: 1000;
    background: #35384b;
    color: #a3a4a9;
    font-family: 'Gotham', sans-serif;
    font-weight: 300;
  }
  .sv-footer.sv--cta-links {
    padding-bottom: 78px;
  }
  .sv-footer a {
    color: #a3a4a9;
    transition: color 0.15s ease-out;
    text-decoration: none;
  }
  .sv-footer a:hover {
    color: #fff;
  }

  .sv-footer__inner:after,
  .sv-footer__inner:before {
    content: '';
    display: table;
  }
  .sv-footer__inner:after {
    clear: both;
  }
  .sv-footer__header {
    display: none;
  }
  .sv-footer__header .sv-footer__inner {
    border-bottom: 1px solid #4c4d50;
  }
  .sv-footer__footer {
    background: #252839;
    font-size: 11px;
    margin-top: 40px;

    .sv-footer__inner {
      padding-bottom: 32px;
    }
  }
  .sv-footer__footer .sv-smallprint {
    margin-bottom: 0;
  }
  .sv-footer__heading {
    color: #fff;
    font-family: 'DomineWebRegular', 'Georgia', 'Palatino Linotype', serif;
    font-size: 18px;
    line-height: 1.25;
    margin: 0 0 12px;
    padding: 0;
    font-weight: 300;
  }
  .sv-footer__subheading {
    font-weight: 300;
    font-size: 12px;
    line-height: 1.75;
    margin: 0 0 6px;
    padding: 0;
    text-transform: uppercase;
  }
  .sv-footer__list {
    font-size: 11px;
    line-height: 17.6px;
    font-weight: 300;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .sv-footer__list-item {
    margin: 0;
    padding: 0;
  }
  .sv-footer__list-item a {
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
  .sv-footer__info .sv-footer__list {
    line-height: 2;
  }
  .sv-footer__info .sv-footer__heading {
    margin-top: 0;
  }
  .sv-footer .sv-social {
    float: right;
  }

  // footer social styles
  .sv-social::after,
  .sv-social::before {
    content: '';
    display: table;
  }
  .sv-social::after {
    clear: both;
  }
  .sv-social__heading {
    color: #313131;
    font-weight: 500;
    font-size: 0.75rem;
    float: left;
    margin: 0;
    padding: 0;
    line-height: 40px;
    padding-right: 20px;
    text-transform: uppercase;
  }
  .sv-social__group {
    float: left;
    list-style: none;
    margin: 0 0 0 10px;
    padding: 0.375rem 0 0;
  }
  .sv-social__item {
    display: inline-block;
    margin: 0 0.3125rem;
    padding: 0;
  }
  a.sv-social__action {
    padding: 0.3125rem;
    height: 20px;
    width: 20px;
    font-size: 0;
  }
  .sv-social__action::after {
    content: '';
    display: block;
    height: 20px;
    width: 20px;
  }
  .sv-social__action.sv--twitter::after {
    background-size: contain;
    height: 1.4375rem;
    width: 1.4375rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1200' height='1227' viewBox='0 0 1200 1227' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23313131' d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z' fill='white'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.71875rem, -0.71875rem);
  }
  .sv-social__action.sv--facebook::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23313131' fill='%23252839' d='M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social__action.sv--youtube::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23313131' fill='%23252839' d='M1280 896q0-37-30-54l-512-320q-31-20-65-2-33 18-33 56v640q0 38 33 56 16 8 31 8 20 0 34-10l512-320q30-17 30-54zm512 0q0 96-1 150t-8.5 136.5-22.5 147.5q-16 73-69 123t-124 58q-222 25-671 25t-671-25q-71-8-124.5-58t-69.5-123q-14-65-21.5-147.5t-8.5-136.5-1-150 1-150 8.5-136.5 22.5-147.5q16-73 69-123t124-58q222-25 671-25t671 25q71 8 124.5 58t69.5 123q14 65 21.5 147.5t8.5 136.5 1 150z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social__action.sv--linkedin::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath style='fill:%23313131' fill='%23252839' d='M507 310.6v185.6H399.4V323.1c0-43.5-15.5-73.2-54.5-73.2-29.7 0-47.4 20-55.2 39.4-2.8 6.9-3.6 16.5-3.6 26.2v180.8H178.5s1.4-293.3 0-323.7h107.6v45.9c-.2.4-.5.7-.7 1.1h.7v-1.1c14.3-22 39.8-53.5 97-53.5 70.8 0 123.9 46.2 123.9 145.6zM65.9 16.6C29.1 16.6 5 40.7 5 72.5c0 31.1 23.4 55.9 59.5 55.9h.7c37.5 0 60.9-24.9 60.9-55.9-.7-31.8-23.4-55.9-60.2-55.9zM11.4 496.2H119V172.6H11.4v323.6zm0 0'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social__action.sv--instagram::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath style='fill:%23313131' fill='%23252839' d='M367.8 6.3H143.4C67.2 6.3 5.3 68.2 5.3 144.4v224.4C5.3 445 67.2 507 143.4 507h224.4C444 507 506 445 506 368.8V144.4C506 68.2 444 6.3 367.8 6.3zm93.8 362.5c0 51.7-42.1 93.8-93.8 93.8H143.4c-51.7 0-93.8-42.1-93.8-93.8V144.4c0-51.7 42.1-93.8 93.8-93.8h224.4c51.7 0 93.8 42.1 93.8 93.8v224.4zm0 0M255.6 127.6c-71.2 0-129 57.9-129 129 0 71.2 57.9 129 129 129s129-57.9 129-129c.1-71.1-57.8-129-129-129zm0 213.6c-46.6 0-84.6-37.9-84.6-84.6 0-46.6 38-84.6 84.6-84.6s84.6 38 84.6 84.6c0 46.7-37.9 84.6-84.6 84.6zm0 0M390.1 89.9c-8.6 0-17 3.5-23 9.5-6.1 6-9.6 14.5-9.6 23.1 0 8.6 3.5 17 9.6 23 6 6 14.4 9.5 23 9.5s17-3.5 23-9.5c6.1-6.1 9.5-14.5 9.5-23 0-8.6-3.5-17-9.5-23.1-6-6-14.4-9.5-23-9.5zm0 0'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social__action.sv--xing::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 272.5 284.5'%3E%3Cpath style='fill:%23313131' fill='%23fefefe' d='M265.8 3.1c-1.1 1.9-1.9 3.4-2.7 4.8C232.6 61.4 202 115 171.4 168.4c-1.2 2.1-1 3.6.1 5.6 19.7 34.5 39.4 69 59 103.5.3.5.5 1 1 1.8-1.4.1-2.5.2-3.5.2-19.2 0-38.4 0-57.6.1-2.3 0-3.6-.7-4.8-2.8-19.4-34.2-38.9-68.4-58.5-102.6-1.3-2.3-1.2-3.9.1-6.1C138 114 168.8 60 199.6 6c1.3-2.2 2.5-3 5-3 19.1.1 38.2.1 57.3.1h3.9zM4.8 196c6-9.9 11.6-19.1 17.2-28.4 9.8-16.2 19.6-32.4 29.6-48.6 1.1-1.8.8-2.9-.1-4.6-11-19.3-21.9-38.7-33-58-1.6-2.8-.8-3 1.8-3 18.2.1 36.4.1 54.6 0 2.1 0 3.2.6 4.3 2.5 11 19.6 22.1 39.1 33.3 58.7 1 1.8.9 2.9-.1 4.6-15.1 24.7-30.2 49.5-45.2 74.3-.8 1.2-1.3 2.5-3.2 2.5H4.8z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social__action.sv--weibo::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23313131' fill='%23252839' d='M675 1284q21-34 11-69t-45-50q-34-14-73-1t-60 46q-22 34-13 68.5t43 50.5 74.5 2.5 62.5-47.5zm94-121q8-13 3.5-26.5t-17.5-18.5q-14-5-28.5.5t-21.5 18.5q-17 31 13 45 14 5 29-.5t22-18.5zm174 107q-45 102-158 150t-224 12q-107-34-147.5-126.5t6.5-187.5q47-93 151.5-139t210.5-19q111 29 158.5 119.5t2.5 190.5zm312-160q-9-96-89-170t-208.5-109-274.5-21q-223 23-369.5 141.5t-132.5 264.5q9 96 89 170t208.5 109 274.5 21q223-23 369.5-141.5t132.5-264.5zm308 4q0 68-37 139.5t-109 137-168.5 117.5-226 83-270.5 31-275-33.5-240.5-93-171.5-151-65-199.5q0-115 69.5-245t197.5-258q169-169 341.5-236t246.5 7q65 64 20 209-4 14-1 20t10 7 14.5-.5 13.5-3.5l6-2q139-59 246-59t153 61q45 63 0 178-2 13-4.5 20t4.5 12.5 12 7.5 17 6q57 18 103 47t80 81.5 34 116.5zm-74-624q42 47 54.5 108.5t-6.5 117.5q-8 23-29.5 34t-44.5 4q-23-8-34-29.5t-4-44.5q20-63-24-111t-107-35q-24 5-45-8t-25-37q-5-24 8-44.5t37-25.5q60-13 119 5.5t101 65.5zm181-163q87 96 112.5 222.5t-13.5 241.5q-9 27-34 40t-52 4-40-34-5-52q28-82 10-172t-80-158q-62-69-148-95.5t-173-8.5q-28 6-52-9.5t-30-43.5 9.5-51.5 43.5-29.5q123-26 244 11.5t208 134.5z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social__action.sv--wechat::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23313131' fill='%23252839' d='M21.502 19.525C23.026 18.42 24 16.787 24 14.971c0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045a.241.241 0 0 0 .241-.241l-.039-.176-.326-1.215-.025-.154a.48.48 0 0 1 .202-.392zM8.675 2.297C3.884 2.297 0 5.533 0 9.526c0 2.178 1.168 4.139 2.997 5.464a.575.575 0 0 1 .243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097a.908.908 0 0 1 .46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012a5.586 5.586 0 0 1-.291-1.771c0-3.641 3.542-6.593 7.911-6.593l.471.012c-.653-3.453-4.24-6.094-8.567-6.094zm5.686 11.711a.964.964 0 1 1 .001-1.927.964.964 0 0 1-.001 1.927zm4.82 0a.964.964 0 1 1 0-1.928.964.964 0 0 1 0 1.928zM5.783 8.369a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312zm5.783 0a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--block .sv-social__item {
    width: 2.25rem;
    height: 2.25rem;
    margin: 0 1px;
    background-color: #999795;
    border-radius: 0.125rem;
  }
  .sv-social.sv--block .sv-social__action {
    width: 2.25rem;
    height: 2.25rem;
  }
  .sv-social.sv--block .sv-social__action.sv--twitter::after {
    background-size: contain;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1200' height='1227' viewBox='0 0 1200 1227' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23ffdf00' d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z' fill='white'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.625rem, -0.625rem);
  }
  .sv-social.sv--block .sv-social__action.sv--facebook::after {
    background-size: contain;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23ffdf00' fill='%23252839' d='M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.625rem, -0.625rem);
  }
  .sv-social.sv--block .sv-social__action.sv--youtube::after {
    background-size: contain;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23ffdf00' fill='%23252839' d='M1280 896q0-37-30-54l-512-320q-31-20-65-2-33 18-33 56v640q0 38 33 56 16 8 31 8 20 0 34-10l512-320q30-17 30-54zm512 0q0 96-1 150t-8.5 136.5-22.5 147.5q-16 73-69 123t-124 58q-222 25-671 25t-671-25q-71-8-124.5-58t-69.5-123q-14-65-21.5-147.5t-8.5-136.5-1-150 1-150 8.5-136.5 22.5-147.5q16-73 69-123t124-58q222-25 671-25t671 25q71 8 124.5 58t69.5 123q14 65 21.5 147.5t8.5 136.5 1 150z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.625rem, -0.625rem);
  }
  .sv-social.sv--block .sv-social__action.sv--weibo::after {
    background-size: contain;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23ffdf00' fill='%23252839' d='M675 1284q21-34 11-69t-45-50q-34-14-73-1t-60 46q-22 34-13 68.5t43 50.5 74.5 2.5 62.5-47.5zm94-121q8-13 3.5-26.5t-17.5-18.5q-14-5-28.5.5t-21.5 18.5q-17 31 13 45 14 5 29-.5t22-18.5zm174 107q-45 102-158 150t-224 12q-107-34-147.5-126.5t6.5-187.5q47-93 151.5-139t210.5-19q111 29 158.5 119.5t2.5 190.5zm312-160q-9-96-89-170t-208.5-109-274.5-21q-223 23-369.5 141.5t-132.5 264.5q9 96 89 170t208.5 109 274.5 21q223-23 369.5-141.5t132.5-264.5zm308 4q0 68-37 139.5t-109 137-168.5 117.5-226 83-270.5 31-275-33.5-240.5-93-171.5-151-65-199.5q0-115 69.5-245t197.5-258q169-169 341.5-236t246.5 7q65 64 20 209-4 14-1 20t10 7 14.5-.5 13.5-3.5l6-2q139-59 246-59t153 61q45 63 0 178-2 13-4.5 20t4.5 12.5 12 7.5 17 6q57 18 103 47t80 81.5 34 116.5zm-74-624q42 47 54.5 108.5t-6.5 117.5q-8 23-29.5 34t-44.5 4q-23-8-34-29.5t-4-44.5q20-63-24-111t-107-35q-24 5-45-8t-25-37q-5-24 8-44.5t37-25.5q60-13 119 5.5t101 65.5zm181-163q87 96 112.5 222.5t-13.5 241.5q-9 27-34 40t-52 4-40-34-5-52q28-82 10-172t-80-158q-62-69-148-95.5t-173-8.5q-28 6-52-9.5t-30-43.5 9.5-51.5 43.5-29.5q123-26 244 11.5t208 134.5z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.625rem, -0.625rem);
  }
  .sv-social.sv--block .sv-social__action.sv--wechat::after {
    background-size: contain;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23ffdf00' fill='%23252839' d='M21.502 19.525C23.026 18.42 24 16.787 24 14.971c0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045a.241.241 0 0 0 .241-.241l-.039-.176-.326-1.215-.025-.154a.48.48 0 0 1 .202-.392zM8.675 2.297C3.884 2.297 0 5.533 0 9.526c0 2.178 1.168 4.139 2.997 5.464a.575.575 0 0 1 .243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097a.908.908 0 0 1 .46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012a5.586 5.586 0 0 1-.291-1.771c0-3.641 3.542-6.593 7.911-6.593l.471.012c-.653-3.453-4.24-6.094-8.567-6.094zm5.686 11.711a.964.964 0 1 1 .001-1.927.964.964 0 0 1-.001 1.927zm4.82 0a.964.964 0 1 1 0-1.928.964.964 0 0 1 0 1.928zM5.783 8.369a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312zm5.783 0a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.625rem, -0.625rem);
  }
  .sv-social.sv--block .sv-social__action.sv--xing::after {
    background-size: contain;
    height: 1.25rem;
    width: 1.25rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 272.5 284.5'%3E%3Cpath style='fill:%23ffdf00' fill='%23fefefe' d='M265.8 3.1c-1.1 1.9-1.9 3.4-2.7 4.8C232.6 61.4 202 115 171.4 168.4c-1.2 2.1-1 3.6.1 5.6 19.7 34.5 39.4 69 59 103.5.3.5.5 1 1 1.8-1.4.1-2.5.2-3.5.2-19.2 0-38.4 0-57.6.1-2.3 0-3.6-.7-4.8-2.8-19.4-34.2-38.9-68.4-58.5-102.6-1.3-2.3-1.2-3.9.1-6.1C138 114 168.8 60 199.6 6c1.3-2.2 2.5-3 5-3 19.1.1 38.2.1 57.3.1h3.9zM4.8 196c6-9.9 11.6-19.1 17.2-28.4 9.8-16.2 19.6-32.4 29.6-48.6 1.1-1.8.8-2.9-.1-4.6-11-19.3-21.9-38.7-33-58-1.6-2.8-.8-3 1.8-3 18.2.1 36.4.1 54.6 0 2.1 0 3.2.6 4.3 2.5 11 19.6 22.1 39.1 33.3 58.7 1 1.8.9 2.9-.1 4.6-15.1 24.7-30.2 49.5-45.2 74.3-.8 1.2-1.3 2.5-3.2 2.5H4.8z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.625rem, -0.625rem);
  }
  .sv-social.sv--inverse .sv-social__heading {
    color: #fff;
  }
  .sv-social.sv--inverse .sv-social__action.sv--twitter::after {
    background-size: contain;
    height: 1.4375rem;
    width: 1.4375rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1200' height='1227' viewBox='0 0 1200 1227' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23fff' d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z' fill='white'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.71875rem, -0.71875rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--facebook::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23fff' fill='%23252839' d='M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--youtube::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23fff' fill='%23252839' d='M1280 896q0-37-30-54l-512-320q-31-20-65-2-33 18-33 56v640q0 38 33 56 16 8 31 8 20 0 34-10l512-320q30-17 30-54zm512 0q0 96-1 150t-8.5 136.5-22.5 147.5q-16 73-69 123t-124 58q-222 25-671 25t-671-25q-71-8-124.5-58t-69.5-123q-14-65-21.5-147.5t-8.5-136.5-1-150 1-150 8.5-136.5 22.5-147.5q16-73 69-123t124-58q222-25 671-25t671 25q71 8 124.5 58t69.5 123q14 65 21.5 147.5t8.5 136.5 1 150z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--linkedin::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath style='fill:%23fff' fill='%23252839' d='M507 310.6v185.6H399.4V323.1c0-43.5-15.5-73.2-54.5-73.2-29.7 0-47.4 20-55.2 39.4-2.8 6.9-3.6 16.5-3.6 26.2v180.8H178.5s1.4-293.3 0-323.7h107.6v45.9c-.2.4-.5.7-.7 1.1h.7v-1.1c14.3-22 39.8-53.5 97-53.5 70.8 0 123.9 46.2 123.9 145.6zM65.9 16.6C29.1 16.6 5 40.7 5 72.5c0 31.1 23.4 55.9 59.5 55.9h.7c37.5 0 60.9-24.9 60.9-55.9-.7-31.8-23.4-55.9-60.2-55.9zM11.4 496.2H119V172.6H11.4v323.6zm0 0'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--instagram::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath style='fill:%23fff' fill='%23252839' d='M367.8 6.3H143.4C67.2 6.3 5.3 68.2 5.3 144.4v224.4C5.3 445 67.2 507 143.4 507h224.4C444 507 506 445 506 368.8V144.4C506 68.2 444 6.3 367.8 6.3zm93.8 362.5c0 51.7-42.1 93.8-93.8 93.8H143.4c-51.7 0-93.8-42.1-93.8-93.8V144.4c0-51.7 42.1-93.8 93.8-93.8h224.4c51.7 0 93.8 42.1 93.8 93.8v224.4zm0 0M255.6 127.6c-71.2 0-129 57.9-129 129 0 71.2 57.9 129 129 129s129-57.9 129-129c.1-71.1-57.8-129-129-129zm0 213.6c-46.6 0-84.6-37.9-84.6-84.6 0-46.6 38-84.6 84.6-84.6s84.6 38 84.6 84.6c0 46.7-37.9 84.6-84.6 84.6zm0 0M390.1 89.9c-8.6 0-17 3.5-23 9.5-6.1 6-9.6 14.5-9.6 23.1 0 8.6 3.5 17 9.6 23 6 6 14.4 9.5 23 9.5s17-3.5 23-9.5c6.1-6.1 9.5-14.5 9.5-23 0-8.6-3.5-17-9.5-23.1-6-6-14.4-9.5-23-9.5zm0 0'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--xing::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 272.5 284.5'%3E%3Cpath style='fill:%23fff' fill='%23fefefe' d='M265.8 3.1c-1.1 1.9-1.9 3.4-2.7 4.8C232.6 61.4 202 115 171.4 168.4c-1.2 2.1-1 3.6.1 5.6 19.7 34.5 39.4 69 59 103.5.3.5.5 1 1 1.8-1.4.1-2.5.2-3.5.2-19.2 0-38.4 0-57.6.1-2.3 0-3.6-.7-4.8-2.8-19.4-34.2-38.9-68.4-58.5-102.6-1.3-2.3-1.2-3.9.1-6.1C138 114 168.8 60 199.6 6c1.3-2.2 2.5-3 5-3 19.1.1 38.2.1 57.3.1h3.9zM4.8 196c6-9.9 11.6-19.1 17.2-28.4 9.8-16.2 19.6-32.4 29.6-48.6 1.1-1.8.8-2.9-.1-4.6-11-19.3-21.9-38.7-33-58-1.6-2.8-.8-3 1.8-3 18.2.1 36.4.1 54.6 0 2.1 0 3.2.6 4.3 2.5 11 19.6 22.1 39.1 33.3 58.7 1 1.8.9 2.9-.1 4.6-15.1 24.7-30.2 49.5-45.2 74.3-.8 1.2-1.3 2.5-3.2 2.5H4.8z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--weibo::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='1792' height='1792' viewBox='0 0 1792 1792' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23fff' fill='%23252839' d='M675 1284q21-34 11-69t-45-50q-34-14-73-1t-60 46q-22 34-13 68.5t43 50.5 74.5 2.5 62.5-47.5zm94-121q8-13 3.5-26.5t-17.5-18.5q-14-5-28.5.5t-21.5 18.5q-17 31 13 45 14 5 29-.5t22-18.5zm174 107q-45 102-158 150t-224 12q-107-34-147.5-126.5t6.5-187.5q47-93 151.5-139t210.5-19q111 29 158.5 119.5t2.5 190.5zm312-160q-9-96-89-170t-208.5-109-274.5-21q-223 23-369.5 141.5t-132.5 264.5q9 96 89 170t208.5 109 274.5 21q223-23 369.5-141.5t132.5-264.5zm308 4q0 68-37 139.5t-109 137-168.5 117.5-226 83-270.5 31-275-33.5-240.5-93-171.5-151-65-199.5q0-115 69.5-245t197.5-258q169-169 341.5-236t246.5 7q65 64 20 209-4 14-1 20t10 7 14.5-.5 13.5-3.5l6-2q139-59 246-59t153 61q45 63 0 178-2 13-4.5 20t4.5 12.5 12 7.5 17 6q57 18 103 47t80 81.5 34 116.5zm-74-624q42 47 54.5 108.5t-6.5 117.5q-8 23-29.5 34t-44.5 4q-23-8-34-29.5t-4-44.5q20-63-24-111t-107-35q-24 5-45-8t-25-37q-5-24 8-44.5t37-25.5q60-13 119 5.5t101 65.5zm181-163q87 96 112.5 222.5t-13.5 241.5q-9 27-34 40t-52 4-40-34-5-52q28-82 10-172t-80-158q-62-69-148-95.5t-173-8.5q-28 6-52-9.5t-30-43.5 9.5-51.5 43.5-29.5q123-26 244 11.5t208 134.5z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }
  .sv-social.sv--inverse .sv-social__action.sv--wechat::after {
    background-size: contain;
    height: 1.5625rem;
    width: 1.5625rem;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath style='fill:%23fff' fill='%23252839' d='M21.502 19.525C23.026 18.42 24 16.787 24 14.971c0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045a.241.241 0 0 0 .241-.241l-.039-.176-.326-1.215-.025-.154a.48.48 0 0 1 .202-.392zM8.675 2.297C3.884 2.297 0 5.533 0 9.526c0 2.178 1.168 4.139 2.997 5.464a.575.575 0 0 1 .243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097a.908.908 0 0 1 .46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012a5.586 5.586 0 0 1-.291-1.771c0-3.641 3.542-6.593 7.911-6.593l.471.012c-.653-3.453-4.24-6.094-8.567-6.094zm5.686 11.711a.964.964 0 1 1 .001-1.927.964.964 0 0 1-.001 1.927zm4.82 0a.964.964 0 1 1 0-1.928.964.964 0 0 1 0 1.928zM5.783 8.369a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312zm5.783 0a1.156 1.156 0 1 1 0-2.312 1.156 1.156 0 0 1 0 2.312z'/%3E%3C/svg%3E");
    left: 50%;
    transform: translate(-0.78125rem, -0.78125rem);
  }

  @media screen and (${(props) => props.theme.media.widthLtLrg}) {
    .sv--sml-5 {
      .sv--sml-6 {
        width: 100%;
      }
    }
  }

  @media screen and (${(props) => props.theme.media.widthLtMed}) {
    .sv-col.sv--xsml-6 {
      width: calc(49.95% - 0.5rem);
    }
    .sv-col.sv--sml-7,
    .sv--sml-5 {
      width: calc(100%);
      margin-top: 20px;
    }
  }
`;
